var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SearchValue"},[_c('vue-good-table',{ref:"searchValue",attrs:{"columns":_vm.columns,"rows":_vm.rows,"group-options":{
        enabled: true
      },"max-height":"200px","fixed-header":false,"styleClass":"vgt-table condensed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }